import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import { VoterPreferenceFilters } from '../../../types';
import VoterPreferenceForm from './VoterPreferenceForm';
import VoterPreferencePrecinctReport from './VoterPreferencePrecinctReport';
import { fetchBarangaysByMunicipality } from '../../../utils/locationUtils';

interface VoterPreferenceReportProps {
}

const VoterPreferenceReport: React.FC<VoterPreferenceReportProps> = () => {
  const [filters, setFilters] = useState<VoterPreferenceFilters>();
  const [barangays, setBarangays] = useState<string[]>([]);

  const onGenerateReport = async (filters: VoterPreferenceFilters) => {
    console.log('Generating report with filters:', filters);
    setFilters(filters);

    // If no barangay is specified, fetch all barangays in the municipality
    if (!filters.barangay) {
      try {
        const fetchedBarangays = await fetchBarangaysByMunicipality(
          filters.region, 
          filters.province, 
          filters.district, 
          filters.municipality
        );
        setBarangays(fetchedBarangays);
      } catch (error) {
        console.error('Error fetching barangays:', error);
        setBarangays([]);
      }
    } else {
      // If a specific barangay is selected, reset barangays list
      setBarangays([]);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Voters Preference
      </Typography>
      <VoterPreferenceForm onGenerateReport={onGenerateReport} />
      
      {filters && (
        <Grid container spacing={3}>
          {/* If no barangay specified, generate reports for all barangays */}
          {barangays.length > 0 ? (
            barangays.map((barangay) => (
              <Grid item xs={12} key={barangay}>
                <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
                  Barangay: {barangay}
                </Typography>
                <VoterPreferencePrecinctReport 
                  filters={{
                    ...filters,
                    barangay: barangay
                  }} 
                />
              </Grid>
            ))
          ) : (
            // If a specific barangay or no barangays, show single report
            filters && <VoterPreferencePrecinctReport filters={filters} />
          )}
        </Grid>
      )}
    </Box>
  );
};

export default VoterPreferenceReport;
